import React, { useState, useEffect } from "react";
import "../../styles/Modals.css";


const ReservationModal = ({ show, mode, reservationData, onClose, onSave }) => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        date: "",
        guests: 1,
        specialRequests: "",
        depositPaid: false,
    });

    useEffect(() => {
        if (show) {
            if (mode === "edit" && reservationData) {
                const isoDate = new Date(reservationData.date);
                const formattedDate = isoDate.toISOString().split("T")[0];

                setFormData({
                    ...reservationData,
                    date: formattedDate,
                });
            } else {
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    date: "",
                    guests: 1,
                    specialRequests: "",
                    depositPaid: false,
                });
            }
        }
    }, [show, mode, reservationData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "date") {
            const [year, month, day] = value.split("-").map(Number);
            const localDate = new Date(year, month - 1, day);
            const dayOfWeek = localDate.getDay(); // 0 = Sunday, 1 = Monday

            if (dayOfWeek === 1) {
                alert("Sorry, reservations are not available on Mondays.");
                return;
            }
        }

        setFormData({
            ...formData,
            [name]: value,
        });
    };



    const handleSubmit = (e) => {
        e.preventDefault();

        onSave({
            ...formData,
            guests: parseInt(formData.guests, 10),
            depositPaid: Boolean(formData.depositPaid),
        });

        onClose();
    };


    if (!show) return null;

    return (
        <div
            className="modal-backdrop"
            onClick={(e) => {
                if (e.target.classList.contains("modal-backdrop")) {
                    onClose();
                }
            }}
        >
            <div className="modal-container">
                <h2>{mode === "edit" ? "Edit Reservation" : "Add Reservation"}</h2>
                <form onSubmit={handleSubmit} className="event-form">

                    <div className="form-group">
                        <label>Date: <span className="required">*</span></label>
                        <input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Name: <span className="required">*</span></label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Phone: <span className="required">*</span></label>
                        <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Email: <span className="required">*</span></label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Guests: <span className="required">*</span></label>
                        <input
                            type="number"
                            name="guests"
                            value={formData.guests}
                            onChange={handleInputChange}
                            min="1"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>
                            <input
                                type="checkbox"
                                name="depositPaid"
                                checked={formData.depositPaid}
                                onChange={(e) =>
                                    setFormData({ ...formData, depositPaid: e.target.checked })
                                }
                            />
                            Deposit Paid
                        </label>
                    </div>

                    <div className="form-group">
                        <label>Special Requests</label>
                        <input
                            type="text"
                            name="specialRequests"
                            value={formData.specialRequests}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="btn-cancel" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="btn-submit">
                            {mode === "edit" ? "Save Changes" : "Add Reservation"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ReservationModal;
